import { CookieTableHeadType, CookieTableBodyType } from '~/static-pages/Cookies/types/Cookies.types'

import { CookieTableBody } from './CookieTableBody'
import { CookieTableHead } from './CookieTableHead'

type CookieTableMobilProps = CookieTableHeadType & CookieTableBodyType

export const CookieTableMobil = (props: CookieTableMobilProps): React.ReactElement => {
  const { tableTitles, name, issuedBy, purpose, optional, storageTime, receiver } = props
  return (
    <table className="w-full flex flex-row flex-no-wrap overflow-hidden my-10">
      <CookieTableHead tableTitles={tableTitles} />
      <CookieTableBody
        issuedBy={issuedBy}
        name={name}
        optional={optional}
        purpose={purpose}
        receiver={receiver}
        storageTime={storageTime}
      />
    </table>
  )
}
